// Appearance of the modern design: 'light' | 'dark' | 'system', chosen in the profile, kept per device.
// Light is the default until the event decides otherwise (dark tokens: .ee-dark in sass/modern/_tokens.scss).
const KEY = 'ee_theme'
export const THEMES = ['system', 'light', 'dark']

const media = window.matchMedia ? window.matchMedia('(prefers-color-scheme: dark)') : null

export function themePref () {
  try {
    const value = localStorage.getItem(KEY)
    return THEMES.includes(value) ? value : 'light'
  } catch (e) {
    return 'light'
  }
}

export function setThemePref (value, root) {
  try {
    localStorage.setItem(KEY, value)
  } catch (e) {}
  if (root) root.$emit('ee-theme', value)
}

export function isDark (pref = themePref()) {
  return pref === 'dark' || (pref === 'system' && !!media && media.matches)
}

// follow the OS when "system" is selected
export function onSystemThemeChange (callback) {
  if (!media) return () => {}
  const handler = () => callback(isDark())
  if (media.addEventListener) media.addEventListener('change', handler)
  else media.addListener(handler)
  return () => (media.removeEventListener ? media.removeEventListener('change', handler) : media.removeListener(handler))
}
